import apiClient from './apiClient';

export interface BotPermission {
  id?: number;
  user_id: number;
  bot_session_id: number;
  admin_id: number;
  can_respond: boolean;
  can_view: boolean;
  can_assign: boolean;
  bot?: {
    id: number;
    session_name: string;
    phone_number: string;
    status: string;
  };
}

export interface Bot {
  id: number;
  session_name: string;
  phone_number: string;
  status: string;
}

export interface UserWithPermissions {
  id: number;
  name: string;
  email: string;
  type: 'attendant' | 'manager';
  status: 'active' | 'blocked';
  botPermissions: BotPermission[];
}

export interface UpdatePermissionsRequest {
  permissions: {
    bot_session_id: number;
    can_respond: boolean;
    can_view: boolean;
    can_assign: boolean;
  }[];
}

class UserBotPermissionService {
  // Buscar permissões de um usuário específico
  async getUserPermissions(userId: number): Promise<BotPermission[]> {
    const response = await apiClient.get(`/user-bot-permissions/users/${userId}/permissions`);
    return response.data.data;
  }

  // Buscar todos os bots disponíveis para o admin
  async getAvailableBots(userId?: number): Promise<Bot[]> {
    const query = userId ? `?userId=${userId}` : '';
    const response = await apiClient.get(`/user-bot-permissions/bots/available${query}`);
    return response.data.data;
  }

  // Atualizar permissões de um usuário
  async updateUserPermissions(userId: number, permissions: UpdatePermissionsRequest): Promise<void> {
    await apiClient.put(`/user-bot-permissions/users/${userId}/permissions`, permissions);
  }

  // Verificar permissão específica de um usuário para um bot
  async checkUserBotPermission(userId: number, botSessionId: number): Promise<{
    can_respond: boolean;
    can_view: boolean;
    can_assign: boolean;
  }> {
    const response = await apiClient.get(`/user-bot-permissions/users/${userId}/bots/${botSessionId}/check`);
    return response.data.data;
  }

  // Buscar todos os usuários com suas permissões de bots
  async getUsersWithBotPermissions(page: number = 1, limit: number = 10): Promise<{
    users: UserWithPermissions[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  }> {
    const response = await apiClient.get(`/user-bot-permissions/users-with-permissions?page=${page}&limit=${limit}`);
    return response.data.data;
  }
}

export const userBotPermissionService = new UserBotPermissionService();







